var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("pui-lightbox", {
    ref: "plantModal",
    attrs: {
      "on-close-callback": _vm.closeModal,
      "close-on-overlay-click": true,
      "dark-background": true,
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function () {
          return [
            _c(
              "div",
              { attrs: { id: "plant-modal", tabindex: "-1", role: "dialog" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "modal-dialog modal-dialog-centered",
                    attrs: { role: "document" },
                  },
                  [
                    _c("div", { staticClass: "modal-content" }, [
                      _c("div", { staticClass: "modal-header" }, [
                        !_vm.data.selected.plant || !_vm.data.selected.plant.id
                          ? _c(
                              "h5",
                              {
                                staticClass: "modal-title",
                                attrs: { id: "plant-modal-label" },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("addNewPlant")) + " "
                                ),
                              ]
                            )
                          : _c(
                              "h5",
                              {
                                staticClass: "modal-title",
                                attrs: { id: "plant-modal-label" },
                              },
                              [_vm._v(" " + _vm._s(_vm.$t("editPlant")) + " ")]
                            ),
                      ]),
                      _c("div", { staticClass: "modal-body pt-3" }, [
                        _c(
                          "div",
                          { staticClass: "input-group input-group-sm mb-3" },
                          [
                            _c("div", { staticClass: "input-group-prepend" }, [
                              _c("span", { staticClass: "input-group-text" }, [
                                _vm._v(_vm._s(_vm.$t("plantName"))),
                              ]),
                            ]),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.plant.name,
                                  expression: "plant.name",
                                  modifiers: { trim: true },
                                },
                              ],
                              class: [
                                { "is-invalid": _vm.getValidateObject("name") },
                                "form-control",
                              ],
                              attrs: {
                                type: "text",
                                placeholder: _vm.$t("plantName"),
                                disabled: _vm.plant.name,
                              },
                              domProps: { value: _vm.plant.name },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.plant,
                                    "name",
                                    $event.target.value.trim()
                                  )
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                            _c(
                              "div",
                              {
                                class: {
                                  "invalid-feedback":
                                    _vm.getValidateObject("name"),
                                },
                              },
                              _vm._l(
                                _vm.getValidateObject("name"),
                                function (error) {
                                  return _c("span", [_vm._v(_vm._s(error))])
                                }
                              ),
                              0
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "input-group input-group-sm mb-3" },
                          [
                            _c("div", { staticClass: "input-group-prepend" }, [
                              _c("span", { staticClass: "input-group-text" }, [
                                _vm._v(_vm._s(_vm.$t("currency"))),
                              ]),
                            ]),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.plant.currency,
                                    expression: "plant.currency",
                                  },
                                ],
                                class: [
                                  {
                                    "is-invalid":
                                      _vm.getValidateObject("Currency"),
                                  },
                                  "form-control",
                                ],
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.plant,
                                      "currency",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                },
                              },
                              _vm._l(_vm.currencies, function (currency) {
                                return _c(
                                  "option",
                                  {
                                    key: currency.code,
                                    domProps: { value: currency.value },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(currency.code) +
                                        " " +
                                        _vm._s(currency.symbol) +
                                        " "
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm.currencyError === true
                              ? _c("div", { staticClass: "currency-error" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("currencyRequired"))),
                                  ]),
                                ])
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "input-group input-group-sm mb-3" },
                          [
                            _c("div", { staticClass: "input-group-prepend" }, [
                              _c("span", { staticClass: "input-group-text" }, [
                                _vm._v(_vm._s(_vm.$t("PMHMapping"))),
                              ]),
                            ]),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.plant.enerlyticsSiteId,
                                    expression: "plant.enerlyticsSiteId",
                                  },
                                ],
                                staticClass: "form-control",
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.plant,
                                      "enerlyticsSiteId",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                },
                              },
                              _vm._l(
                                _vm.enerlyticsPlants,
                                function (enerlyticsSite) {
                                  return _c(
                                    "option",
                                    {
                                      key: enerlyticsSite.enerlyticsSiteId,
                                      staticClass: "plant-info",
                                      domProps: {
                                        value: enerlyticsSite.enerlyticsSiteId,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            enerlyticsSite.enerlyticsSiteId
                                              ? _vm.$t("plant") +
                                                  ": " +
                                                  enerlyticsSite.enerlyticsDisplayName
                                              : enerlyticsSite.enerlyticsDisplayName
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "input-group input-group-sm mb-3" },
                          [
                            _c("div", { staticClass: "input-group-prepend" }, [
                              _c("span", { staticClass: "input-group-text" }, [
                                _vm._v(_vm._s(_vm.$t("plantAbbreviation"))),
                              ]),
                            ]),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.plant.abbreviation,
                                  expression: "plant.abbreviation",
                                  modifiers: { trim: true },
                                },
                              ],
                              class: [
                                {
                                  "is-invalid":
                                    _vm.getValidateObject("abbreviation"),
                                },
                                "form-control",
                              ],
                              attrs: {
                                type: "text",
                                placeholder: _vm.$t("plantAbbreviation"),
                              },
                              domProps: { value: _vm.plant.abbreviation },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.plant,
                                    "abbreviation",
                                    $event.target.value.trim()
                                  )
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                            _c(
                              "div",
                              {
                                class: {
                                  "invalid-feedback":
                                    _vm.getValidateObject("abbreviation"),
                                },
                              },
                              _vm._l(
                                _vm.getValidateObject("abbreviation"),
                                function (error) {
                                  return _c("span", [_vm._v(_vm._s(error))])
                                }
                              ),
                              0
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "input-group input-group-sm mb-3" },
                          [
                            _c("div", { staticClass: "input-group-prepend" }, [
                              _c("span", { staticClass: "input-group-text" }, [
                                _vm._v(_vm._s(_vm.$t("plantSID"))),
                              ]),
                            ]),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.plant.sid,
                                  expression: "plant.sid",
                                  modifiers: { trim: true },
                                },
                              ],
                              class: [
                                {
                                  "is-invalid":
                                    _vm.getValidateObject("plantSID"),
                                },
                                "form-control",
                              ],
                              attrs: {
                                type: "text",
                                placeholder: _vm.$t("plantSID"),
                                disabled: "",
                              },
                              domProps: { value: _vm.plant.sid },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.plant,
                                    "sid",
                                    $event.target.value.trim()
                                  )
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                            _c(
                              "div",
                              {
                                class: {
                                  "invalid-feedback":
                                    _vm.getValidateObject("plantSID"),
                                },
                              },
                              _vm._l(
                                _vm.getValidateObject("plantSID"),
                                function (error) {
                                  return _c("span", [_vm._v(_vm._s(error))])
                                }
                              ),
                              0
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "alert alert-dismissible fade",
                            class: {
                              show: _vm.showResultBox,
                              "alert-success": !_vm.resultError,
                              "alert-danger": _vm.resultError,
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.result) + " ")]
                        ),
                      ]),
                      _c("div", { staticClass: "modal-footer" }, [
                        _c(
                          "span",
                          {
                            staticClass: "wait",
                            class: { "fade-in": _vm.waitingForSave === true },
                          },
                          [_vm._v(_vm._s(_vm.$t("pleaseWait")))]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-secondary btn-sm",
                            attrs: {
                              type: "button",
                              disabled: _vm.waitingForSave,
                              "data-dismiss": "modal",
                            },
                            on: { click: _vm.closeModal },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                        ),
                        !_vm.data.selected.plant || !_vm.data.selected.plant.id
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-sm",
                                attrs: {
                                  type: "button",
                                  disabled:
                                    !_vm.isUserAdmin || _vm.waitingForSave,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.savePlant()
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(_vm.$t("addPlant")) + " ")]
                            )
                          : _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-sm",
                                attrs: {
                                  type: "button",
                                  disabled:
                                    !_vm.isUserAdmin || _vm.waitingForSave,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.savePlant()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("saveChanges")) + " "
                                ),
                              ]
                            ),
                      ]),
                    ]),
                  ]
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }